export const resetInputs = () => {
  const idsToReset = [
    "exerciseAddSets",
    "exerciseAddReps",
    "exerciseAddRpe",
    "exerciseAddLoad",
    "exerciseAddWeightLoad",
    "exerciseAddLoadDrop",
    "exerciseAddRepsTwo",
    "exerciseAddRepsThree",
  ];
  idsToReset.forEach((id) => {
    const input = document.getElementById(id);
    if (input) {
      input.value = "";
    }
  });
};
